import React, { useEffect, useState } from 'react' 
import Slider from "react-slick";
import LazyLoad from 'react-lazyload';
import {getSliders} from "../Service/Api"
const s3_URL = "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com";
const DEFAULT_IMAGE = 'https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/slide11.jpg'
const HomeSlider = () => {


  const [sliders, setSliders] = useState([]);


   useEffect(() => {
         const fetchSliders = async () => {
             try {
                 const data = await getSliders();
 
                 const visibleSliders = Array.isArray(data)
                     ? data
                         .filter((item) => item.school === "Senior")
                         .filter((item) => item.visibility === false)
                         .sort((a, b) => a.position - b.position)
                     : [];
 
                 setSliders(visibleSliders);
             } catch (error) {
                 console.error("Error loading senior ncsr sliders:", error);
                 setSliders([]);
             }
         };
 
         fetchSliders();
     }, []);


  const settings = {
    autoplay: true,
    infinite: true,
    autoplaySpeed: 4000,
    speed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    arrows: false,
    adaptiveHeight: true,
 
  };

  
 return(
  <>
  
          <Slider {...settings}>
                {sliders.length === 0 ? (
                    <div className="carousel-item active">
                        <LazyLoad>
                            <img
                                src={DEFAULT_IMAGE}
                                className="d-block w-100"
                                alt="Nirmala School Rajkot"
                            />
                        </LazyLoad>
                    </div>
                ) : (
                    sliders.map((slider, index) => (
                        <div
                            className={`carousel-item ${index === 0 ? "active" : ""}`}
                            key={slider._id || index}
                        >
                            <LazyLoad>
                                <img
                                    src={`${s3_URL}/${slider.attachment}`}
                                    className="d-block w-100"
                                    alt={slider.title || "Nirmala School Rajkot"}
                                />
                            </LazyLoad>
                        </div>
                    ))
                )}
            </Slider>
  </>
 )

}

export default HomeSlider
